module.exports = "/img/check.svg?d659c2d1eb31e2f8f72a67856e337577";